export default function buildValues(start, end, success, cancel) {
  const values = {};

  if (start) {
    values.start = start;
  }

  if (end) {
    values.end = end;
  }
  if (Object.entries(values).length === 0) {
    success(null)
  } else {
    success(values);
  }
}
